// extracted by mini-css-extract-plugin
export default {"liveNotificationContainerHeight":"409px","sentimentAnalysisContainerHeight":"400px","adminThreadsContainerHeight":"540px"};